// extracted by mini-css-extract-plugin
export default {"container":"Auth_container__TLYdG","authWrapper":"Auth_authWrapper__LkWSF","left":"Auth_left__nCNI0","right":"Auth_right__UHcpz"};